export default __webpack_public_path__ + "static/media/search.19f101bb.svg";